export const monthsList = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const defaultLimit = 9;
export const defaultLimitAdminProjectRoleDetail = 7;
export const DEFAULT_CHUNK_SIZE = 10 * 1024 * 1024 
